module.exports = __webpack_public_path__ + "img/box-arrow-up.689e33e6.svg";